module.exports = "/assets/landing-rw/instagram/insta-feed-1@2x.jpg?JZn2i8W";